module.exports = __webpack_public_path__ + "img/DROP-2-820x1024.4f405e72.png";